import { render, staticRenderFns } from "./action.vue?vue&type=template&id=d85d4638&scoped=true"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"
import style0 from "./action.vue?vue&type=style&index=0&id=d85d4638&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85d4638",
  null
  
)

export default component.exports